import { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import { BatchResultResponse } from '@/models/request';

export type BulkFailureReason = BatchResultResponse['failed'][number]['reason'];

export const BULK_FAILURE_REASON_MESSAGES: Record<BulkFailureReason, MessageDescriptor> = {
  not_found: msg({
    id: 'requests.bulk.failure.not-found',
    message: 'Request not found',
  }),
  forbidden: msg({
    id: 'requests.bulk.failure.forbidden',
    message: 'You do not have permission',
  }),
  draft_request: msg({
    id: 'requests.bulk.failure.draft-request',
    message: 'Draft request',
  }),
  already_archived: msg({
    id: 'requests.bulk.failure.already-archived',
    message: 'Already archived',
  }),
  task_not_available: msg({
    id: 'requests.bulk.failure.task-not-available',
    message: 'This task is not available',
  }),
  payment_strategy_required: msg({
    id: 'requests.bulk.failure.payment-strategy-required',
    message: 'A payment strategy is required',
  }),
  missing_prices: msg({
    id: 'requests.bulk.failure.missing-prices',
    message: 'Prices are incomplete',
  }),
  unknown: msg({
    id: 'requests.bulk.failure.unknown',
    message: 'An unexpected error occurred',
  }),
};
